module.exports = "/assets/data/5ad71ab092848d46463e1822bfa9845c-IP30.data.json";